<template>
  <div class="section pt-5">
    <div v-if="patient">
      <div class="title is-4">
        {{ `${patient.first_name} ${patient.surname}` }}
      </div>
      <div class="subtitle is-6 mb-0" v-if="patient.id_card_number">
        <span class="icon">
          <i class="fa fa-id-card"></i>
        </span>
        <span>{{ patient.id_card_number }}</span>
      </div>
      <div class="subtitle is-6" v-if="patient.birthdate">
        <span class="icon">
          <i class="fa fa-birthday-cake"></i>
        </span>
        <span>{{ format_date(patient.birthdate) }}</span>
      </div>
      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            class="is-active"
            data-tab="inscriptions"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="student icon" aria-hidden="true"></i>
              <span>{{ $t("inscriptions") }}</span>
            </a>
          </li>
          <li data-tab="account" @click="change_active_tab($event, this)">
            <a>
              <i class="money icon mb-0" aria-hidden="true"></i>
              <span>{{ $t("account") }}</span>
            </a>
          </li>
          <li data-tab="documents" @click="change_active_tab($event, this)">
            <a>
              <i class="file image icon mb-0" aria-hidden="true"></i>
              <span>{{ $t("documents") }}</span>
            </a>
          </li>
          <li data-tab="score" @click="change_active_tab($event, this)">
            <a>
              <i class="student icon mb-0" aria-hidden="true"></i>
              <span>{{ $t("score") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="" data-tab="inscriptions">
          <inscriptions ref="inscriptions" />
        </div>
        <div class="is-hidden" data-tab="account">account here</div>
        <div class="is-hidden" data-tab="documents">documents here</div>
        <div class="is-hidden" data-tab="score">score here</div>
      </div>
      <!-- <pre>{{ patient }}</pre> -->
    </div>
    <div v-else>
      <div class="notification is-danger">
        <button class="delete" @click="refresh"></button>
        {{ $t("patient_not_found") }}
      </div>
    </div>
  </div>
</template>

<script>
import { get, error_message, change_active_tab, format_date } from "@/utils";
import Inscriptions from "./profile_components/inscriptions/Index.vue";
// import Hospitalization from "./profile_components/hospitalization/Index.vue";
// import Documents from "./profile_components/documents/Index.vue";
// import MedicalServices from "./profile_components/medical_services/Index.vue";
// import Prescriptions from "./profile_components/prescriptions/Index.vue";

export default {
  name: "PatientProfile",
  components: {
    Inscriptions,
    // Appointments,
    // Hospitalization,
    // Documents,
    // MedicalServices,
    // Prescriptions,
  },
  data() {
    return {
      patient: {},
    };
  },
  methods: {
    format_date,
    change_active_tab,
    refresh() {
      let v = this;
      get("/student/profile", { uuid: v.$route.params.uuid })
        .then((patient) => {
          v.patient = patient;

          v.$refs.inscriptions.refresh();
        })
        .catch((error) => {
          v.patient = undefined;
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
  created() {},
};
</script>

<style scoped></style>
